import React, { useState } from 'react';
import Navbar from '../component/Navbar';
import Footer from '../component/Footer';
import { Link } from 'react-router-dom';
import Arrow from './Arrow';
import Generalsidebar from './Generalsidebar';

function Community() {
  const [showSidebar, setShowSidebar] = useState(false);

  const userInfo = JSON.parse(localStorage.getItem('userLoggedIn'))
    ? JSON.parse(localStorage.getItem('userLoggedIn'))
    : { firstName: '' };

  console.log('userInfo', userInfo);
  function handleArrowClick() {
    setShowSidebar(true);
  }

  return (
    <div className='bg-[#D9D9D9]'>
      <Navbar />
      <div onClick={handleArrowClick} className='absolute top-24 left-12 z-20'>
        <Arrow />
      </div>
      <div className={showSidebar ? 'show-sidebar' : 'hidden'}>
        <Generalsidebar setShowSidebar={setShowSidebar} />
      </div>
      <div>
        <h1 className='text-[#295700] text-center font-bold text-2xl mt-8 mb-4'>
          Welcome to Thrive Community
        </h1>
        <p className='text-center text-[#295700] text-lg mb-16 px-12'>
          Nurture your mind, connect with others and thrive together on our
          community page
        </p>
        <section className='relative pb-28'>
          <div className='flex flex-col items-center gap-8 md:w-[80%] md:mx-auto md:flex-row md:justify-between md:items-stretch '>
            <div className='bg-white py-8 flex flex-col items-center w-4/5 px-8 rounded-md shadow-lg'>
              <div className='p-1 w-8 h-8 rounded-full bg-green-200 flex items-center justify-center'>
                <img
                  src='https://res.cloudinary.com/druryt8ny/image/upload/v1700601086/gxqmvcvuzc3q9sjgm1bb.png'
                  alt
                />
              </div>
              <h2 className='text-[#295700] text-center text-md py-2 font-semibold'>
                RESOURCES
              </h2>
              <p className='text-sm text-center pb-4 text-green-600'>
                Enrich your mind with educational videos and fun engaging
                riddles
              </p>
              <button className='text-green-500 text-xs font-semibold border-2 border-green-600 px-6 py-1 rounded-lg'>
                <Link to='/mainresources'>GET STARTED</Link>
              </button>
            </div>
            <div className='bg-red-100 py-8 flex flex-col items-center w-4/5 px-8 rounded-md shadow-lg'>
              <div className='p-1 w-8 h-8 rounded-full bg-green-200 flex items-center justify-center'>
                <img
                  src='https://res.cloudinary.com/druryt8ny/image/upload/v1700601119/pijlxx4l1ul5wnqtjwii.png'
                  alt
                />
              </div>
              <h2 className='text-[#295700] text-center text-md py-2 font-semibold'>
                JOIN THE FORUM
              </h2>
              <p className='text-sm text-center pb-4 text-[#295700]'>
                Our Community support fosters motivation for collective
                advancement
              </p>
              <Link
                to='/forum'
                className='text-white bg-[#295700] text-xs font-semibold px-6 py-1 rounded-lg'>
                GET STARTED
              </Link>
            </div>
            <div className='bg-white py-8 flex flex-col items-center w-4/5 px-8 rounded-md shadow-lg'>
              <div className='p-1 w-8 h-8 rounded-full bg-green-100 flex items-center justify-center'>
                <img
                  src='https://res.cloudinary.com/druryt8ny/image/upload/v1700601156/nsyqjv8fzxpetxozyaph.png'
                  alt
                />
              </div>
              <h2 className='text-[#295700] text-center text-md py-2 font-semibold'>
                THERAPY
              </h2>
              <p className='text-sm text-center pb-4 text-green-600'>
                Embark on a path to Emotional well-being with our proficient
                therapists
              </p>
              <Link to='/therapy'>
                <button className='text-green-500 text-xs font-semibold border-2 border-green-600 px-6 py-1 rounded-lg'>
                  GET STARTED
                </button>
              </Link>
            </div>
          </div>
        </section>
      </div>

      <div className='relative z-40'>
      <Footer /></div>
    </div>
  );
}

export default Community;
